import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {Navigate, useNavigate} from 'react-router-dom'
import axios from 'axios'
import {defaultRegion, KTSVG, useDebounce} from '../../../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
// import { GetData } from '../AllContactsList/SubscriberSlice/SubscriberSlice'
import {
  DeleteData,
  GetAllData,
  // GetFilterContactTag,
  // getTagContactCount,
} from './TagSlice/TagsSlices'
import {startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import CreateTagsPopup from './Modal/CreateTagsPopup'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
// import Select from 'react-select'
import InsertNewData from '../../../../Components/InsertNewData'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {toast} from 'react-toastify'
import {useListTag} from './useListTagHooks'
import {Tag} from '../../../../../services/cellcast.v3.types'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {cellcastV3Api, useDeleteTagMutation} from '../../../../../services/cellcast.v3'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {useResponsive} from '../../../../hooks/useResponsive'
import {TagMobileCard} from './TagMobileCard'
import './TagsList.scss'

export const ContactsBredcrumb: Array<PageLink> = [
  {
    title: 'Contacts      ',
    path: '/tags',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

interface TagsListProps {
  newNavigation?: boolean
  setTotal?: (value?: number) => void
}

const TagsList = (props: TagsListProps) => {
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const {fetchTagsData, tagslist, TagsCount} = useListTag()
  const [deleteTag] = useDeleteTagMutation()
  const [isShowPaginate, setShowPaginate] = useState(true)
  const {isMobile} = useResponsive()

  const API_URL = ENV().REACT_APP_API_URL
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const navigate = useNavigate()
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)

  // const tagslist = useSelector((state: any) => state?.tags?.tags?.data)
  // const TagsCount = useSelector(getTagContactCount)

  const dispatch = useDispatch()
  const [createTag, setCreateTag] = useState(false)
  const [tagName, setTagName] = useState({})

  //Delete All state
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [contactTagCount, setContactTagCount] = useState(new Map())

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  useEffect(() => {
    fetchTagsData()
  }, [])

  useEffect(() => {
    if (tagslist && tagslist.totalPages === 0) {
      setShowPaginate(false)
    }
  }, [tagslist])

  useEffect(() => {
    if (props?.setTotal &&  tagslist?.total !== undefined) {
      props?.setTotal(tagslist?.total)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagslist?.total])

  const debouncedSearchTerm = useDebounce(page?.search, 1000)
  useEffect(() => {
    dispatch(startLoadding())
    if (isDefaultRegion) {
      dispatch(GetAllData(page))
    } else {
      fetchTagsData({
        ...page,
        page: parseInt(String(page.page)),
        size: parseInt(String(page.size)),
      })
    }
  }, [debouncedSearchTerm, page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      if (isDefaultRegion) {
        dispatch(
          DeleteData({
            tagIds: [...deleteIds],
          })
        )
      } else {
        deleteTag(deleteIds).then(() => {
          fetchTagsData({
            ...page,
            page: parseInt(String(page.page)),
            size: parseInt(String(page.size)),
          })
        })
      }

      setConfirm(false)
      setCheckList([])
    }
  }, [confirm])

  const createTagPopup = useMemo(
    () => (
      <CreateTagsPopup
        tagName={tagName}
        setTagName={setTagName}
        show={createTag}
        callback={() =>
          fetchTagsData({
            ...page,
            page: parseInt(String(page.page)),
            size: parseInt(String(page.size)),
          })
        }
        handleClose={() => setCreateTag(false)}
      />
    ),
    [createTag, tagName]
  )
  const handleEdit = (val: any) => {
    setTagName({
      id: val?._id,
      name: val?.name,
      color: val?.color,
    })
    setCreateTag(true)
  }
  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds(checkList)
  }

  const handleSingleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }

  const handleCheckAll = () => {
    if (checkList?.length == tagslist?.items?.length) {
      setCheckList([])
    } else {
      let list = tagslist?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }

  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete Tag?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  useEffect(() => {
    if (tagslist?.items?.length && !isDefaultRegion) {
      MenuComponent.reinitialization()
      Promise.all(
        tagslist?.items?.map((it: any) => {
          return dispatch<any>(
            cellcastV3Api.endpoints.fetchContactCount.initiate({
              tag_ids: [it._id],
            })
          ).unwrap()
        })
      ).then((res: any) => {
        const tagWithContactCount = tagslist?.items?.map((it: any, idx: any) => {
          return {...it, contactCount: res[idx]?.data}
        })
        const map = new Map(tagWithContactCount.map((tag: any) => [tag._id, tag.contactCount]))
        setContactTagCount(map)
      })
    }
  }, [tagslist, dispatch])

  const handleExport = (e: any) => {
    axios
      .get(`${API_URL}tags/exportTagContacts/${e}`, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self')
      })
  }

  return (
    <>
      {confirmation}
      {createTagPopup}

      <div className='card mb-0'>
        <div className={`card-header border-0 pt-12 ${isMobile ? 'px-4' : ''} ${isMobile ? 'tags-list-header-mobile' : ''}`}>
          <div className={`card-title d-flex ${isMobile ? 'flex-column gap-3' : 'align-items-center'}`}>
            <div className={`d-flex align-items-center position-relative my-1 ${isMobile ? 'w-100' : ''}`}>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className={`form-control form-control-solid ${isMobile ? 'w-100' : 'w-250px'} ps-14`}
                placeholder='Search tag'
                onChange={(e: any) => setPage({...page, search: e.target.value})}
              />
            </div>
          </div>
          {!props?.newNavigation ? (
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Tags</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Here you can see all your tags</span>
            </h3>
          ) : null}
          {AuthenticateUser('create-tag') && (
            <div className={`card-toolbar m-0 ${isMobile ? 'w-100' : ''}`}>
              <div className={`d-flex gap-3 align-items-center ${isMobile ? 'w-100' : ''}`}>
                <button
                  className={`btn btn-primary ${isMobile ? 'flex-fill' : ''}`}
                  onClick={() => {
                    setTagName('')
                    setCreateTag(true)
                  }}
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  Create
                </button>
              </div>
            </div>
          )}
        </div>
        {tagslist?.items?.length > 0 ? (
          <div className={`card-body pt-2 pb-2 ${isMobile ? 'px-4' : ''}`}>
            <div className='tab-content'>
              {isMobile ? (
                /* Mobile view: Card layout */
                <div className='mobile-tags-list'>
                  {tagslist?.items?.map((val: Tag, i: number) => {
                    const tagWithCount = {
                      ...val,
                      contactCount: isDefaultRegion
                        ? TagsCount?.length > 0
                          ? TagsCount?.find((key: any) => key?.id == val?._id)?.count
                          : undefined
                        : contactTagCount.get(val?._id),
                    }
                    return (
                      <TagMobileCard
                        key={i}
                        tag={tagWithCount}
                        isDefaultRegion={isDefaultRegion}
                        onEdit={handleEdit}
                        onDelete={handleSingleDelete}
                        onExport={handleExport}
                        onViewContacts={(tagId) => {
                          navigate('/filterContact', {state: tagId})
                        }}
                      />
                    )
                  })}
                </div>
              ) : (
                /* Desktop view: Table layout */
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold text-muted text-uppercase'>
                        <th>TAG NAME</th>
                        <th>DATE</th>
                        <th>TIME</th>
                        <th>CONTACTS</th>
                        <th className='w-100px'>Action</th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600'>
                      {tagslist?.items?.map((val: Tag, i: number) => (
                        <tr key={i}>
                          <td
                            onClick={() => {
                              navigate('/filterContact', {state: val?._id})
                            }}
                            className='fw-bold cursor-pointer px-2'
                          >
                            <span
                              key={i}
                              className='btn'
                              style={{
                                color: val?.color ? 'white' : 'black',
                                backgroundColor: val?.color ? val?.color : '',
                              }}
                            >
                              {val?.name}
                            </span>
                          </td>
                          <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                          <td>{moment(val?.createdAt).format('LT')}</td>
                          <td>
                            {isDefaultRegion
                              ? TagsCount?.length > 0
                                ? TagsCount?.find((key: any) => key?.id == val?._id)?.count
                                : '..counting'
                              : contactTagCount.get(val?._id)}
                          </td>
                          <td>
                            <div className='row'>
                              {AuthenticateUser('edit-tag') && (
                                <a
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  onClick={() => handleEdit(val)}
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <i className='bi bi-pencil-fill'></i>
                                  </span>
                                </a>
                              )}
                              <span
                                className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                data-kt-menu-trigger='hover'
                                data-kt-menu-placement='bottom-end'
                              >
                                <i className='bi bi-three-dots fs-5'></i>
                              </span>
                              <div
                                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                                data-kt-menu='true'
                              >
                                {(AuthenticateUser('send-quick-sms') && isDefaultRegion) && (
                                  <div className='menu-item px-3'>
                                    <a
                                      onClick={() => {
                                        navigate(`/new-message`, {
                                          state: {
                                            selectedType: 'segmentOrTags',
                                            data: `tag_${val?._id}`,
                                          },
                                        })
                                      }}
                                      className='menu-link px-3'
                                    >
                                      Run campaign
                                    </a>
                                  </div>
                                )}
                                {AuthenticateUser('tags-list') && (
                                  <div
                                    onClick={() => {
                                      navigate('/filterContact', {state: val?._id})
                                    }}
                                    className='menu-item px-3'
                                  >
                                    <span className='menu-link px-3 aside-footer flex-column-auto'>
                                      View contacts
                                    </span>
                                  </div>
                                )}
                                {(AuthenticateUser('export-tagged-contacts') && isDefaultRegion) && (
                                  <div
                                    onClick={() => handleExport(val?._id)}
                                    className='menu-item px-3'
                                  >
                                    <span className='menu-link px-3 aside-footer flex-column-auto'>
                                      Export as CSV
                                    </span>
                                  </div>
                                )}
                                <div className='menu-item px-3'>
                                  <span
                                    className='menu-link px-3'
                                    onClick={() => {
                                      navigator.clipboard.writeText(val?._id)
                                      toast.success('Successfully copied tag id')
                                    }}
                                    data-kt-users-table-filter='copy_row'
                                  >
                                    Copy ID
                                  </span>
                                </div>
                                {AuthenticateUser('delete-tag') && (
                                  <div className='menu-item px-3'>
                                    <span
                                      className='menu-link px-3 text-danger'
                                      onClick={() => handleSingleDelete(val?._id)}
                                      data-kt-users-table-filter='delete_row'
                                    >
                                      Delete
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        ) : (
          <InsertNewData
            message={{
              title: `No Tag setup (yet!)`,
              subtitle: `How about tagging your contacts? Go to All Contacts > Select Contacts > Select Tag contacts under ”Actions”. You can also add a list and tag all contacts from that list`,
            }}
            buttonName={{
              name: 'Create tag',
              link: '',
              popup: true,
              buttonFun: () => setCreateTag(true),
            }}
          />
        )}

        {isShowPaginate && (
          <div className={`abcd ps-10 pe-5 pb-5 ${isMobile ? 'px-4' : ''}`}>
            <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})} value={page.size}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={tagslist?.total}>ALL</option>
            </select>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={tagslist?.totalPages}
              onPageChange={(e) => setPage({...page, page: e.selected + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default TagsList
